export default __webpack_public_path__ + "static/media/1023.8969e5c1.png";